/* no navegador essa função é síncrona */

function clearLocalStorage() {
  localStorage.removeItem(`@${process.env.REACT_APP_NAME}:dataUser`);
}

export default clearLocalStorage;
